import React from 'react';

import type {BadgeCounts} from './types';
import LevelBadge from 'assets/images/adaptive/LevelBadge';
import {PROFICIENCY_LEVELS} from 'client/AdaptiveSubjects/constants';
import {Text, WithTooltip} from '@albert-io/atomic';

const BADGE_LEVELS: {levelNum: 1 | 2 | 3}[] = [{levelNum: 1}, {levelNum: 2}, {levelNum: 3}];

interface BadgeCountProps {
  levelNum: 1 | 2 | 3;
  count: number;
}

function BadgeCount({levelNum, count}: BadgeCountProps) {
  'use memo';

  const isEmpty = count === 0;
  return (
    <WithTooltip theme='light' content={`${PROFICIENCY_LEVELS[levelNum]}`}>
      <div className='flex items-center gap-x0-half rounded-x1 border border-solid border-border-subtle px-x1 py-x0-half'>
        <LevelBadge
          levelNum={levelNum}
          width={32}
          height={32}
          empty={isEmpty}
          className='fill-background-bold!'
        />
        <Text>{count}</Text>
      </div>
    </WithTooltip>
  );
}

interface BadgesAchievedProps {
  badgeCounts: BadgeCounts;
}

export function BadgesAchieved({badgeCounts}: BadgesAchievedProps) {
  'use memo';

  const newBadgeCounts = {
    1: badgeCounts[1] + badgeCounts[2] + badgeCounts[3],
    2: badgeCounts[2] + badgeCounts[3],
    3: badgeCounts[3]
  };

  return (
    <div className='flex items-center gap-x1'>
      {BADGE_LEVELS.map(({levelNum}) => (
        <BadgeCount key={levelNum} levelNum={levelNum} count={newBadgeCounts[levelNum]} />
      ))}
    </div>
  );
}
